module.exports = __webpack_public_path__ + "static/media/receipt.430e7834.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-verification/receipt.png
// module id = 1690
// module chunks = 0